export { default } from './BazaarVoice';
